import React, { useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import CensusStatistics from 'components/common/census/census-review/CensusStatistics';
import CensusStatisticsEnrollmentPageStore, {
  CensusStatisticsEnrollmentPageStoreContext,
  useCensusStatisticsEnrollmentPageStore,
} from 'store/pages/enrollment/census-stats-enrollment/pageStore';
import { observer } from 'mobx-react-lite';
import PageHeader from 'components/common/census/census-review/PageHeader';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const pageStore = useCensusStatisticsEnrollmentPageStore();
  return (
    <>
      <PageHeader pageStore={pageStore} />
      <CensusStatistics pageStore={pageStore} />
    </>
  );
});

// @deprecated  This is an old standalone page, the newer approach renders it as a part of the add-employees page.
const CensusReviewPage: React.FC = () => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useMemo(
    () => new CensusStatisticsEnrollmentPageStore({ groupId, enrollmentPeriodId: periodId }),
    [],
  );

  return (
    <ProposalStatusLayout>
      <CensusStatisticsEnrollmentPageStoreContext.Provider value={pageStore}>
        <PageWrapperStyled>
          <PageContent />
        </PageWrapperStyled>
      </CensusStatisticsEnrollmentPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default CensusReviewPage;
